import { createSelector } from '@reduxjs/toolkit';

import { COLLECTION_IDS } from '@/constants/collections';
import getLocationMarkerKey from '@/features/cars/helpers/getLocationMarkerKey';

import configSelector from './config';

/**
 * Возвращает список идентификаторов коллекций данных по местоположению автомобиля,
 * в соответствии с установленными настройками в конфигурации приложения.
 */
const locationIdsSelector = createSelector(configSelector, config => {
  const locationMarkerKey = getLocationMarkerKey(config);

  const locationTypes = Array.isArray(locationMarkerKey)
    ? locationMarkerKey
    : [locationMarkerKey];

  const locationCollectionIds: Array<string> = [];

  locationTypes.forEach(locationType => {
    switch (locationType) {
      case 'country':
        locationCollectionIds.push(COLLECTION_IDS.dealersCountries);
        break;
      case 'city':
        locationCollectionIds.push(COLLECTION_IDS.dealersCities);
        break;
      case 'dealer':
        locationCollectionIds.push(COLLECTION_IDS.dealersDealers);
        break;
      case 'dealership':
        locationCollectionIds.push(COLLECTION_IDS.dealersDealership);
        break;
      default:
    }
  });

  return locationCollectionIds;
});

export default locationIdsSelector;
